import React from 'react';

import { dateOnlySlashesFormat, formatUtcDate } from 'App/services/DateService';
import PropTypes from 'prop-types';
import { formatPhone } from 'App/utils';
import { priorAuthorizationReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const PAApprovedReviewContent = ({ priorAuthorizationReferralDetails, status, medicationList }) => {
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details (Prior Authorization)</strong>

                <div>Status: {status}</div>
                <div>PA Number: {priorAuthorizationReferralDetails.paNumber || '--'}</div>
                <div>
                    PA Follow Up Phone Number: {formatPhone(priorAuthorizationReferralDetails.followUpPhone) || '--'}
                </div>
                <div>
                    Effective Start and End Date:{' '}
                    {formatUtcDate({
                        date: priorAuthorizationReferralDetails.effectiveStartDate?.toISOString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}{' '}
                    -{' '}
                    {formatUtcDate({
                        date: priorAuthorizationReferralDetails.effectiveEndDate?.toISOString(),
                        format: dateOnlySlashesFormat,
                    }) || '--'}
                </div>

                <div> Medication Authorized Quantity: {medicationList[0]?.data?.authorizedQuantity || '--'}</div>
                <div> Unit of Measure: {medicationList[0]?.data?.authorizedUom?.name || '--'}</div>
                <div> Is Approval NDC Specific: {medicationList[0]?.data?.ndcSpecificApproval?.name || '--'}</div>
                <div> Approved NDC: {medicationList[0]?.data?.approvedNdc || '--'}</div>

                <div>
                    How was approval received?: {priorAuthorizationReferralDetails.methodApprovalReceived?.name || '--'}
                </div>
            </ReviewSectionStyle>

            <ReviewSectionStyle>
                <strong>Notes</strong>
                <div>{priorAuthorizationReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

PAApprovedReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    priorAuthorizationReferralDetails: priorAuthorizationReferralDetailsPropType.isRequired,
    medicationList: PropTypes.arrayOf(
        PropTypes.shape({
            medication: PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
            data: PropTypes.shape({
                authorizedQuantity: PropTypes.string,
                authorizedUom: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
                ndcSpecificApproval: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
                approvedNdc: PropTypes.string,
            }),
        })
    ).isRequired,
};

export default PAApprovedReviewContent;
